export const quotes = {
  quotes: {
    addToCartSuccess: 'Product {{code}} Added to cart',
    email: 'Email',
    endCustomer: 'End Customer',
    competitor: 'Competitor',
    additionalInformation: 'Additional Information',
    attachments: 'Attachments',
    sepecificProductBtn: 'Request for Specific Products',
    basedOnAttributesBtn: 'Request Based on Attribute',
    submit: 'Request Quote',
    noProduct: 'Please add products to your quote to start the process',
    searchTypes: {
      BASIC: 'Request for Specific Products',
      ADVANCED: 'Request Based on Attribute',
    },
    noContent: 'No products found. Please review your search terms and try again.',
    postSuccess: 'Successful requested quotation.',
    searchByAttributeInfo: 'You can also click here to search for your products using product characteristics.',
    basicSearch: {
      searchbox: {
        placeholder: 'Search by name, code, part number or catalog number.',
      },
    },
    history: {
      tableHeader: {
        quoteNumber: 'Quote #',
        catalogNumber: 'Catalog #',
        customerPartNumber: 'Customer #',
        quoteName: 'Quote Name',
        endCustomer: 'Final Customer',
        location: 'Location',
        status: 'Status',
        approvalDate: 'Approval Date',
        expirationDate: 'Expiration Date',
        partNumber: 'Part #',
        qty: 'QTY',
        uom: 'UOM',
        sellingPrice: 'Quoted Unit Price',
        lineNumber: 'Line #',
      },
      search: 'Search',
      addToCart: 'Add to Cart',
      noQutoeFound: 'No quote available',
      termsAndConditions1: 'This quote is subject to seller’s',
      termsAndConditions2: 'Terms and Conditions',
      termsAndConditions3:
        "of Sale (the 'Terms and Conditions') effective on the date the purchase order is received by seller and they are incorporated in full by this reference. Seller limits acceptance to the Terms and Conditions, and objects to any other additional or different terms in buyer’s purchase order or acceptance",
      requestNewQuote: 'Would you like to request a new Quote? Click here.',
      searchByDateRange: 'Use the fields below to search for quotes by date range.',
      form: {
        from: 'From',
        to: 'To',
      },
    },
    quoteDetails: {
      quoteConditions: 'Quote Conditions',
      noContent: 'No Content',
    },
    quoteItem: {
      speedRPM: 'Speed RPM',
      outputHP: 'Output HP',
      voltage: 'Voltage (V)',
      frameSize: 'Frame Size',
      outputKW: 'Output KW',
      mounting: 'Mounting',
      phase: 'Phase',
      enclosure: 'Enclosure',
      catalogNumber: 'Catalog#',
      partNumber: 'Part#',
      quoteQty: 'Quote Qty#',
      orderFrequency: 'Order Frequency#',
      description: 'Description',
      unitPrice: 'Unit Price',
      requestPrice: 'Request Price',
      remove: 'Remove',
      selectOption: 'Select an option',
    },
    validation: {
      noProductSelected: 'No Product was selected to quote, please find a product, and try again.',
      invalidFields: 'One or more fields is not valid, please check the <strong>Quotation Form</strong> and try again.',
      invalidGeneralInfo: 'One or more fields is not valid, please check the <strong>General Information Form</strong> and try again.',
    },
    productFinder: 'Product Finder',
    quotationForm: 'Quotation Form',
    generalInformation: 'General Information',
  },
};